import styled from 'styled-components';

export const Container = styled.div``;

export const TextBlock = styled.p`
  a {
    text-decoration: underline;
  }
`;
